// Serviço de validação e máscaras reutilizável

import { formatCpfCnpjInput, validateCNPJ as validateCnpjDocument } from '../utils/cpfCnpjUtils';

export function maskPhone(value: string): string {
  // Remove tudo que não for número
  value = value.replace(/\D/g, '');
  // Aplica máscara (formato brasileiro)
  if (value.length > 11) value = value.slice(0, 11);
  if (value.length > 10) {
    return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (value.length > 5) {
    return value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  } else if (value.length > 2) {
    return value.replace(/(\d{2})(\d{0,5})/, '($1) $2');
  } else {
    return value;
  }
}

export function normalizeWhatsAppPhoneDigits(value: string | undefined | null): string {
  if (!value)
  {
    return '';
  }

  return value.replace(/\D/g, '');
}

export function maskWhatsAppPhone(value: string): string {
  const trimmed = value.trim();
  const digits = normalizeWhatsAppPhoneDigits(value).slice(0, 15);
  if (!digits)
  {
    return trimmed.startsWith('+') ? '+' : '';
  }

  return `+${digits}`;
}

export function isValidWhatsAppPhone(value: string | undefined | null): boolean {
  const digits = normalizeWhatsAppPhoneDigits(value);
  return digits.length >= 8 && digits.length <= 15;
}

export function maskCNPJ(value: string): string {
  return formatCpfCnpjInput(value);
}

export function validatePhone(value: string): boolean {
  // Aceita apenas números e tamanho 10 ou 11
  const onlyNumbers = value.replace(/\D/g, '');
  return onlyNumbers.length === 10 || onlyNumbers.length === 11;
}

export function validateCNPJ(value: string): boolean {
  return validateCnpjDocument(value);
}

export function limitLength(value: string, max: number): string {
  return value.slice(0, max);
}
